/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import {
  Alert, Checkbox, Icon, IconButton, LinearProgress, Pagination, Paper,
  Snackbar, SnackbarCloseReason, Table, TableBody, TableCell,
  TableContainer, TableFooter, TableHead, TableRow, Chip, Box, Typography,
  useTheme, alpha
} from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LayoutBaseDeFinanceiro } from '../../../shared/layouts';
import { useDebounce } from '../../../shared/hooks';
import { Environment } from '../../../shared/environment';
import dayjs from 'dayjs';
import { ContasReceberService, IListagemContasReceber } from '../../../shared/services/api/Financeiro/ContasReceber';
import { FerramentasDaListagemFinanceiro } from '../../../shared/components';
import { DialoDesconto } from './DialogDesconto';
import { DialoBaixa } from './DialogBaixa';
import { v4 as uuidv4 } from 'uuid';
import { DialoBaixaCheque } from './DialogBaixaCheque';
import PDFReceber from './ImpressaoReceber';

export const ListagemContasReceber: React.FC = () => {
  const theme = useTheme();
  const [searchParams, setSearchParams] = useSearchParams();
  const { debounce } = useDebounce();
  const navigate = useNavigate();
  const [rows, setRows] = useState<IListagemContasReceber[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const hoje = dayjs();
  const primeiroDiaMes = dayjs().startOf('month');

  const [dataInicial, setDataInicial] = useState(primeiroDiaMes.format('YYYY-MM-DD'));
  const [dataFinal, setDataFinal] = useState(hoje.format('YYYY-MM-DD'));


  const [totalCount, setTotalCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [selecionado, setSelecionado] = useState(0);
  const [open, setOpen] = useState(false);
  const [openBaixa, setOpenBaixa] = useState(false);
  const [openCheque, setOpenCheque] = useState(false);
  const [nome, setNome] = useState('');
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  };
  const guuid = uuidv4();

  const busca = useMemo(() => {
    return searchParams.get('busca') || '';
  }, [searchParams]);

  const basicselect = useMemo(() => {
    return searchParams.get('basicselect') || 'parceiro';
  }, [searchParams]);

  const basicstatus = useMemo(() => {
    return searchParams.get('basicstatus') || 'false';
  }, [searchParams]);

  const parceiroselect = useMemo(() => {
    return searchParams.get('parceiroselect') || '';
  }, [searchParams]);

  const parceiro = useMemo(() => {
    return searchParams.get('parceiro') || '';
  }, [searchParams]);

  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);

  const mensagemVazia = useMemo(() => {
  if (basicselect === 'parceiro') {
    if (!parceiroselect) {
      return 'Pesquise um parceiro';
    }
    return 'Nenhum registro encontrado para este parceiro';
  }

  if (basicselect === 'data') {
    return 'Não temos nenhum registro entre essas datas';
  }

  if (busca !== '') {
    return 'Não temos nenhum registro com esse número';
  }

  return 'Nenhum registro encontrado';
}, [basicselect, parceiroselect, busca]);

  useEffect(() => {
    const urlDataI = searchParams.get('datai') || dataInicial;
    const urlDataF = searchParams.get('dataf') || dataFinal;

    setDataInicial(urlDataI);
    setDataFinal(urlDataF);
  }, [searchParams]);
  useEffect(() => {

    if (basicselect === 'data') {
      const hoje = dayjs();
      const primeiroDiaMes = dayjs().startOf('month');

      setDataInicial(primeiroDiaMes.format('YYYY-MM-DD'));
      setDataFinal(hoje.format('YYYY-MM-DD'));
      setSearchParams({
        basicselect,
        datai: primeiroDiaMes.format('YYYY-MM-DD'),
        dataf: hoje.format('YYYY-MM-DD'),
        pagina: '1'
      });
    }

    setRows([]);
  }, [basicselect]);
  useEffect(() => {
    if (basicselect === 'data') {
      setIsLoading(true);

      ContasReceberService.getAll(pagina, parceiroselect, 'data', dataInicial, dataFinal)
        .then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            setTotalCount(result.totalCount);
            setTotal(result.total);
            setSelecionado(result.selecionado);
            setRows(result.data);
          }
        });
    }
  }, [basicselect, dataInicial, dataFinal, pagina,]);

  useEffect(() => {
    if (parceiroselect !== '') {
      setNome(parceiro);
      ContasReceberService.getAll(pagina, parceiroselect, 'parceiro')
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            setTotalCount(result.totalCount);
            setTotal(result.total);
            setSelecionado(result.selecionado);
            setRows(result.data);
          }
        });
    }
  }, [basicstatus, parceiroselect, pagina]);

  useEffect(() => {
    setIsLoading(true);
    if (busca !== '') {
      debounce(() => {
        ContasReceberService.getAll(pagina, busca, 'numero')
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            }
            else if (!result.data || result.data.length === 0) {
              // quando não encontrar nada
              setRows([]);
              setTotalCount(0);
              setTotal(0);
              setSelecionado(0);

            } else {
              // quando encontrar registros
              setTotalCount(1);
              setTotal(result.total);
              setSelecionado(result.selecionado);
              setRows(result.data);
            }
          });
      });
    }
    setIsLoading(false)
    setRows([]);

  }, [busca]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = event.target;
    const index = rows.findIndex(row => row.idrec === id);
    if (index === -1) return;
    const updatedRow = { ...rows[index], marcado: checked };
    const updatedRows = [...rows.slice(0, index), updatedRow, ...rows.slice(index + 1)];
    setRows(updatedRows);
    const valorNumerico = Number(updatedRow.vreceber);
    const valueToUpdate = checked ? valorNumerico : -valorNumerico;
    setSelecionado(currentSelecionado => currentSelecionado + valueToUpdate);
  };
  const handleSelectAllChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    const updatedRows = rows.map(row => ({ ...row, marcado: checked }));
    setRows(updatedRows);
    if (checked) {
      const totalSelecionado = updatedRows.reduce((acc, row) => {
        const valorNumerico = Number(row.vreceber);
        return acc + valorNumerico;
      }, 0);
      setSelecionado(totalSelecionado);
    } else {
      setSelecionado(0);
    }
  };

  const handleClose = (newValue?: string) => {
    setOpen(false);
    if (newValue) {
      // setValue(newValue); 
    }
  };

  const handleCloseBaixa = (newValue?: string) => {
    setOpenBaixa(false);
    if (newValue === 'true') {
      ContasReceberService.getAll(pagina, parceiroselect, 'parceiro')
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            setTotalCount(result.totalCount);
            setTotal(result.total);
            setSelecionado(result.selecionado);
            setRows(result.data);
          }
        });
    }
  };

  const handleCloseCheque = (newValue?: string) => {
    setOpenCheque(false);
    if (newValue === 'true') {
      ContasReceberService.getAll(pagina, parceiroselect, 'parceiro')
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            setTotalCount(result.totalCount);
            setTotal(result.total);
            setSelecionado(result.selecionado);
            setRows(result.data);
          }
        });
    }
  };
  const handleDesconto = () => {
    if (totalCount != 0) {
      const filteredList = rows.filter((item) => item.marcado === true);
      setRows(filteredList);
      setOpen(true);
    }
  };
  const handleBaixa = () => {
    if (totalCount != 0) {
      const filteredList = rows.filter((item) => item.marcado === true);
      setRows(filteredList);
      setOpenBaixa(true);
    }
  };
  const handleCheque = () => {
    if (totalCount != 0) {
      const filteredList = rows.filter((item) => item.marcado === true);
      setRows(filteredList);
      setOpenCheque(true);
    }
  };

  const handleSave = async () => {
    if (totalCount != 0) {
      setIsLoading(true);
      const marcados = rows.map(listItem => ({
        idrec: listItem.idrec,
        marcado: listItem.marcado,
        desconto: listItem.desconto,
        vreceber: listItem.vreceber,
      }));
      try {
        const result = await ContasReceberService.Marcados(marcados);
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        }
      } catch (error) {
        setIsLoading(false);
        setTms('error');
        setMsg('Ocorreu um erro ao processar sua solicitação.');
        setOpenmsg(true);
      }
    }
  };
  const handleDesc = (dados?: IListagemContasReceber[]) => {
    if (dados) {
      setRows(dados);
    }
  };
  const handletotal = (valor?: number) => {
    if (valor) {
      setSelecionado(valor);
    }
  };
  const handlePrint = () => {
    setIsLoading(true);
    if (selecionado != 0) {
      const filteredList = rows.filter((item) => item.marcado === true);
      PDFReceber(filteredList, total, nome);
    } else {
      setTms('error');
      setMsg('Selecione uma Conta');
      setOpenmsg(true);
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  const isVencida = (vencimento: Date) => {
    return dayjs(vencimento).isBefore(dayjs(), 'day');
  };
  return (
    <LayoutBaseDeFinanceiro
      titulo='Contas a Receber'
      labelSelecionado='Selecionado'
      labeltotal='Total Receber'
      total={total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      selecionado={selecionado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      barraDeFerramentas={
        <FerramentasDaListagemFinanceiro
          mostrarInputBusca={basicselect === 'r.numerodoc'}
          mostrarInputData={basicselect === 'data'}
          mostrarAutoComplete={basicselect === 'parceiro'}
          mostrarInputBasicSelect
          mostrarBotaoCheque={true}
          dataInicial={dataInicial}
          dataFinal={dataFinal}
          textSelectFalse='Receber'
          textSelectTrue='Recebidas'
          textoDaBusca={busca}
          textoDoSelect={basicselect}
          textoDoStatus={basicstatus}
          disbilitarBaixar={basicstatus === 'true' ? true : false}
          disbilitarDesconto={basicstatus === 'true' ? true : false}
          disbilitarSalvar={basicstatus === 'true' ? true : false}
          disbilitarCheque={basicstatus === 'true' ? true : false}
          disbilitarImprimir={
            basicselect !== 'parceiro' || basicstatus === 'true'
          }
          textoBotaoNovo='Adicionar'
          aoClicarEmNovo={() => navigate('/contasreceber/novo')}
          aoClicarEmDesconto={handleDesconto}
          aoClicarEmImpressao={() => handlePrint()}
          aoClicarEmSalvar={handleSave}
          aoClicarEmBaixa={handleBaixa}
          aoClicarEmCheque={handleCheque}
          aoMudarDataInicial={(data) =>
            setSearchParams(
              {
                basicselect: 'data',
                datai: data,
                dataf: dataFinal,
                pagina: '1'
              },
              { replace: true }
            )
          }

          aoMudarDataFinal={(data) =>
            setSearchParams(
              {
                basicselect: 'data',
                datai: dataInicial,
                dataf: data,
                pagina: '1'
              },
              { replace: true }
            )
          }

          aoMudarTextoDoParceiro={(texto, texto1) => setSearchParams({ busca: '', basicstatus: basicstatus, parceiroselect: texto, pagina: '1' }, { replace: true })}
          aoMudarTextoDoStatus={texto => setSearchParams({ busca: '', parceiroselect: parceiroselect, pagina: '1', basicstatus: texto }, { replace: true })}
          aoMudarTextoDeBusca={texto => setSearchParams({ busca: texto, basicselect: basicselect })}
          aoMudarTextoDoSelect={textoselect => setSearchParams({ busca: '', basicselect: textoselect, parceiroselect: parceiroselect, pagina: '1' }, { replace: true })}
        />
      }
    >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>

      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{
          mx: 1,
          mb: 1,
          borderRadius: 2,
          overflow: 'auto',
          maxHeight: 'calc(100vh - 200px)',
          boxShadow: theme.shadows[1],
          '&:hover': {
            boxShadow: theme.shadows[2]
          },
          width: '98%' // Garante que ocupa 100% da largura disponível
        }}
      >
        <Table
          size="small"
          sx={{
            minWidth: 1000,
            tableLayout: 'auto',
          }}
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: alpha(theme.palette.primary.main, 0.08) }}>
              <TableCell padding="checkbox" sx={{ width: '5%', px: 0.5 }}>
                <Checkbox
                  checked={rows.length > 0 && rows.every(row => row.marcado)}
                  onChange={handleSelectAllChange}
                  color="primary"
                  size="small"
                />
              </TableCell>
              <TableCell align='center' sx={{ fontWeight: 'bold', width: '8%', px: 0.5 }}>Emissão</TableCell>
              <TableCell align='center' sx={{ fontWeight: 'bold', width: '10%', px: 0.5 }}>Vencimento</TableCell>
              <TableCell align='left' sx={{ fontWeight: 'bold', width: '*', px: 0.5 }}>Parceiros</TableCell>
              <TableCell align='right' sx={{ fontWeight: 'bold', width: '5%', px: 0.5 }}>Número</TableCell>
              <TableCell align='right' sx={{ fontWeight: 'bold', width: '8%', px: 0.5 }}>Valor</TableCell>
              <TableCell align='right' sx={{ fontWeight: 'bold', width: '8%', px: 0.5 }}>Parcela</TableCell>
              <TableCell align='right' sx={{ fontWeight: 'bold', width: '8%', px: 0.5 }}>Juros/Acré.</TableCell>
              <TableCell align='right' sx={{ fontWeight: 'bold', width: '8%', px: 0.5 }}>Recebido</TableCell>
              <TableCell align='right' sx={{ fontWeight: 'bold', width: '8%', px: 0.5 }}>Desconto</TableCell>
              <TableCell align='right' sx={{ fontWeight: 'bold', width: '8%', px: 0.5 }}>Receber</TableCell>
              <TableCell align='center' sx={{ fontWeight: 'bold', width: '9%', px: 0.5 }}>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => {
              const vencida = isVencida(row.vencimento);
              return (
                <TableRow
                  key={row.idrec}
                  hover
                  sx={{
                    cursor: 'pointer',
                    backgroundColor: row.marcado ? alpha(theme.palette.primary.light, 0.08) : 'inherit',
                    '&:hover': {
                      backgroundColor: alpha(theme.palette.primary.light, 0.12)
                    }
                  }}
                >
                  <TableCell padding="checkbox" sx={{ width: '5%', px: 0.5 }}>
                    <Checkbox
                      checked={row.marcado}
                      id={row.idrec}
                      onChange={handleChange}
                      color="primary"
                      size="small"
                    />
                  </TableCell>
                  <TableCell align='center' sx={{ px: 0.5, fontSize: '0.75rem' }}>
                    {dayjs(row.emissao).format('DD/MM/YY')}
                  </TableCell>
                  <TableCell align='center' sx={{ px: 0.5, fontSize: '0.75rem' }}>
                    <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column">
                      {dayjs(row.vencimento).format('DD/MM/YY')}
                      {vencida && (
                        <Chip
                          label="Vencida"
                          size="small"
                          color="error"
                          sx={{ mt: 0.3, height: '16px', fontSize: '0.55rem', minWidth: '45px' }}
                        />
                      )}
                    </Box>
                  </TableCell>
                  <TableCell align='left' sx={{ fontFamily: 'monospace', fontSize: '0.75rem', px: 0.5 }}>
                    {row.parceiros}
                  </TableCell>
                  <TableCell align='right' sx={{ fontFamily: 'monospace', fontSize: '0.75rem', px: 0.5 }}>
                    {row.numero}
                  </TableCell>
                  <TableCell align='right' sx={{ fontFamily: 'monospace', fontWeight: 'bold', fontSize: '0.75rem', px: 0.5 }}>
                    {Number(row.venda).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                  <TableCell align='right' sx={{ fontFamily: 'monospace', fontSize: '0.75rem', px: 0.5 }}>
                    {Number(row.vparcela).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                  <TableCell align='right' sx={{ fontFamily: 'monospace', color: theme.palette.warning.dark, fontSize: '0.75rem', px: 0.5 }}>
                    {Number(row.acrescimo).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                  <TableCell align='right' sx={{ fontFamily: 'monospace', color: theme.palette.success.main, fontSize: '0.75rem', px: 0.5 }}>
                    {Number(row.vrecebido).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                  <TableCell align='right' sx={{ fontFamily: 'monospace', color: theme.palette.info.main, fontSize: '0.75rem', px: 0.5 }}>
                    {Number(row.desconto).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                  <TableCell align='right' sx={{ fontFamily: 'monospace', fontWeight: 'bold', color: vencida ? theme.palette.error.main : 'inherit', fontSize: '0.75rem', px: 0.5 }}>
                    {Number(row.vreceber).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                  <TableCell align='center' sx={{ px: 0.5 }}>
                    <IconButton
                      size='small'
                      onClick={() => navigate(`/contasreceber/${row.idrec}`)}
                      sx={{
                        backgroundColor: alpha(theme.palette.primary.main, 0.08),
                        padding: '3px',
                        '&:hover': {
                          backgroundColor: alpha(theme.palette.primary.main, 0.15)
                        }
                      }}
                    >
                      <Icon sx={{ fontSize: '16px' }}>edit</Icon>
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
          {rows.length === 0 && !isLoading && (
            <TableRow>
              <TableCell colSpan={12} align="center" sx={{ py: 3 }}>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <Icon sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }}>receipt</Icon>
                  <Typography variant="h6" color="text.secondary">
                   {mensagemVazia}
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
          )}
          <TableFooter>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={12}>
                  <LinearProgress variant='indeterminate' />
                </TableCell>
              </TableRow>
            )}
          </TableFooter>
        </Table>
      </TableContainer>
      <DialoDesconto
        open={open}
        onClose={handleClose}
        dados={rows}
        onDados={handleDesc}
        ontotal={handletotal}
        vselecionado={selecionado}
      />
      <DialoBaixa
        value={guuid}
        open={openBaixa}
        onClose={handleCloseBaixa}
        dados={rows}
        onDados={handleDesc}
        ontotal={handletotal}
        vselecionado={selecionado}
      />
      <DialoBaixaCheque
        value={guuid}
        open={openCheque}
        onClose={handleCloseCheque}
        dados={rows}
        onDados={handleDesc}
        ontotal={handletotal}
        vselecionado={selecionado}
      />
    </LayoutBaseDeFinanceiro>
  );
};